import React, {
  forwardRef,
  useState,
  useMemo,
  useCallback,
  useRef
} from "react";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import { FieldTypes } from "utils/formUtils";
import GenericMappingForm from "../GenericMappingForm";
import { Form } from "antd";
import { isEmpty, uniqBy } from "lodash";

const Crunch42MappingForm = forwardRef(function Crunch42MappingForm(props, ref) {
  const [form] = Form.useForm();
  const IntRef = useRef({});
  const [mappedList] = useState(() => {
    //using mappedProjectList to preserve the selected project when API fails
    if (props.record) {
      const { collectionId, collectionName, apiIds, apiNames } = props.record;
      let api = {};
      if (!isEmpty(apiIds)) {
        const apiIdArray = apiIds.split(",");
        const apiNameArray = apiNames.split(",");
        api = {
          [collectionId]: apiIdArray.map((id, index) => ({
            id,
            name: apiNameArray[index],
          })),
        };
      }
      return { collection: [{ id: collectionId, name: collectionName }], api };
    }
    return { collection: [], api: {} };
  });
  const projectRef = useRef({ collection: mappedList.collection, api: mappedList.api });

  const fetchCollection = useCallback((params) => {
    const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName,{login_id: props.loginConfigId, ...params});
    promise.then((response) => {
      let { projects } = response;
      if (mappedList["collection"].length > 0 && !isEmpty(projects)) {
        response.projects = uniqBy(
          [...projects, ...mappedList["collection"]],
          "id"
        );
      }
      projectRef.current['collection'] = [...projectRef.current['collection'], ...response.projects];
    });
    return { promise, cancel }
  }, [props, mappedList]);

  const fetchAPI = useCallback((params) => {
    const { promise, cancel } =
      ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, {login_id: props.loginConfigId, ...params});

    promise
      .then((response) => {
        const { projects } = response;
        if (mappedList["api"][params.project] && mappedList["api"][params.project].length > 0 && !isEmpty(projects)) {
          response.projects = uniqBy(
            [...projects, ...mappedList["api"][params.project]],
            "id"
          );
        }
        if(isEmpty(projectRef.current['api'][params.project])) projectRef.current['api'][params.project] = [];
        projectRef.current['api'][params.project] = [...projectRef.current['api'][params.project], ...response.projects];
      })
    return { promise, cancel }
  },
    [mappedList, props]
  );


  const getExtraFieldsData = useCallback((config) => {
    const { collectionId, apiIds = [] } = config;
    console.log(projectRef, collectionId)
    const collectionName = projectRef.current['collection'].find(
      (company) => company.id === collectionId
    )?.name;
    const data = projectRef.current['api'][collectionId]?.reduce(
      (acc, cv) => {
        const { id, name } = cv;
        if (apiIds.includes(id)) {
          acc.id.push(id);
          acc.name.push(name);
        }
        return acc;
      },
      { id: [], name: [] }
    );
  
    return {
      collectionId,
      collectionName,
      apiIds: !isEmpty(data.id) ? data.id.join() : undefined,
      apiNames: !isEmpty(data.id) ? data.name.join() : undefined
    };
  }, []);

  const onAPICollectionChange = useCallback((value, field) => {
    const { name } = field;
    const configurations = form.getFieldValue("configurations") || [];
    let updatedConfiguration = [...configurations];
    updatedConfiguration[name] = {
      ...updatedConfiguration[name],
      apiIds: undefined,
    };
    form.setFieldsValue({ configurations: updatedConfiguration });
  }, [form]);

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
    const { collectionId, apiIds } = config;
    return {
      collectionId,
      ...(apiIds && { apiIds: apiIds.split(",") })
    };
  }, []);

  const isProjectFieldDisabled = useCallback((fieldKey, form) => {
    const fieldConfiguration = form.getFieldValue("configurations")[fieldKey];
    return !fieldConfiguration || !fieldConfiguration.collectionId;
  }, []);

  const extraFields = useMemo(() => [{
    name: "collectionId",
    colSpan: 10,
    type: FieldTypes.SELECT_WITH_PAGINATED_DATA,
    label: "API Collection",
    required: true,
    props: {
      startPage: 1,
      api: fetchCollection,
      onChange: onAPICollectionChange,
      autoFocus: true
    },
  },
  {
    name: "apiIds",
    colSpan: 12,
    type: FieldTypes.SELECT_WITH_PAGINATED_DATA,
    label: "API Name",
    propsGenerator: (fieldKey) => ({
      disabled: isProjectFieldDisabled(fieldKey, form),
    }),
    props: {
      startPage: 1,
      setExtraProps: (field, listField) => {
        const allConfigs = form.getFieldsValue().configurations;
        const project = allConfigs[listField.name]?.collectionId;
        if (!IntRef.current[project]) {
          IntRef.current[project] = { project };
        }
        return {
          api: project && fetchAPI,
          apiParams: IntRef.current[project],
          resetOptionsProp: project,
          mode: "multiple",
          allowClear: true,
        }
      }
    }
  }], [onAPICollectionChange, isProjectFieldDisabled, form, fetchCollection, fetchAPI]);

  return (
    <GenericMappingForm
      ref={ref}
      {...props}
      form={form}
      getExtraFieldsData={getExtraFieldsData}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      extraFields={extraFields}
    />
  );
});

export default Crunch42MappingForm;
